import store from 'client/store';

export default {
  path: 'display',
  component: () => import(/* webpackChunkName: "event" */ './wrapper.vue'),
  beforeEnter: function (to, from, next) {
    const event = store.state.events.current
    Promise.all([
      store.dispatch("displays.load", {
        eventId: event.id
      }),
      store.dispatch("displayTemplates.load", {
        organisationId: event.organisationId,
      }),
    ]).then( next )
  },
  children: [{
    path: '/',
    component: () => import(/* webpackChunkName: "event" */ './displayWrapper.vue'),
    children: [{
      path: '/',
      name: 'event.display.list',
      component: () => import(/* webpackChunkName: "event" */ './list.vue'),
    },{
      path: 'add',
      name: 'event.display.add',
      component: () => import(/* webpackChunkName: "event" */ './add.vue'),
    }, {
      path: 'edit/:displayId',
      name: 'event.display.view',
      component: () => import(/* webpackChunkName: "event" */ './view.vue'),
    }]
  },{
    path: 'images',
    component: () => import(/* webpackChunkName: "event" */ './imageWrapper.vue'),
    beforeEnter: function (to, from, next) {
      store.dispatch("displayImages.load", {
        eventId: to.params.eventId
      }).then( next )
    },
    children: [{
      path: '/',
      name: 'event.display.images.list',
      component: () => import(/* webpackChunkName: "event" */ './imageList.vue'),
    }, {
      path: 'add',
      name: 'event.display.images.add',
      component: () => import(/* webpackChunkName: "event" */ './imageAdd.vue'),
    }, {
      path: ':imageId',
      name: 'event.display.images.view',
      component: () => import(/* webpackChunkName: "event" */ './imageView.vue'),
    }],
  }],
};
